export const PORTALS = {
  MANAGER: {
    id: 'manager',
    displayName: 'Manager',
  },
  AUDITOR: {
    id: 'auditor',
    displayName: 'Auditor',
  },
  QA: {
    id: 'qa',
    displayName: 'QA',
  },
  CLIENT: {
    id: 'client',
    displayName: 'Client',
  },
};

const PORTAL_PORTS = {
  [PORTALS.MANAGER.id]: 3000,
  [PORTALS.AUDITOR.id]: 3002,
  [PORTALS.QA.id]: 3001,
  [PORTALS.CLIENT.id]: 3003,
};

export const getPortalUrl = portalId => {
  const hostname = window.location.hostname;
  if (hostname.includes('dev')) {
    return `https://dev-${portalId}.revintegrity.com/`;
  }
  if (hostname.includes('staging')) {
    return `https://staging-${portalId}.revintegrity.com/`;
  }
  if (hostname.includes('localhost')) {
    return `http://localhost:${PORTAL_PORTS[portalId]}/`;
  }
  return `https://${portalId}.revintegrity.com/`;
};

const CURRENT_PORTAL_ID = PORTALS.QA.id;

export const portalLinks = Object.values(PORTALS)
  .filter(portal => portal.id !== CURRENT_PORTAL_ID)
  .map(portal => ({
    name: portal.displayName,
    url: getPortalUrl(portal.id),
  }));
